const RejectedIcon = (props: any) => (
    <button {...props}
        style={{
            backgroundColor: props?.disabled ? 'gray' : '#ffdede',
            borderColor: props?.disabled ? 'gray' : 'red',
            borderRadius: 50,
            color: 'red',
            width: 80,
            height: 28,
            fontSize: 14,
            fontWeight: 'normal',
        }}
    >
        Rejected
    </button>
);

export default RejectedIcon;